import { createFeatureSelector, createSelector } from '@ngrx/store';
import { id } from '@wonder-core-ng/interfaces/id.type';
import { IChartDataEntry } from './interfaces/query-engine.interface';
import * as fromQueryEngine from './query-engine.reducer';

export const selectQueryEngineState = createFeatureSelector<fromQueryEngine.State>(
  fromQueryEngine.queryEngineFeatureKey
);

export const selectAllChartData = createSelector(
  selectQueryEngineState,
  (state: fromQueryEngine.State) => state.chartData
);

export const selectChartData = (chartId: id) =>
  createSelector(
    selectQueryEngineState,
    (state: fromQueryEngine.State): IChartDataEntry | null =>
      state.chartData[String(chartId)] ?? null
  );

/** Charts whose last request failed: what tells a stuck loader apart from a real wait. */
export const selectFailedCharts = createSelector(
  selectQueryEngineState,
  (state) => state.failedCharts
);

export const selectHttpResult = createSelector(
  selectQueryEngineState,
  (state: fromQueryEngine.State) => state.httpResult
);
